export default __webpack_public_path__ + "static/media/busch-jaeger-icons.6676d04b.ttf";